import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { getSocket } from '../../services/socket';
import { useAccounts } from '../../context/AccountContext';
import TradeTable from '../../components/TradeTable';
import PendingOrdersTable from '../../components/PendingOrdersTable';

export default function OpenTrades() {
  const { scopeParams } = useAccounts();
  const [trades, setTrades]   = useState([]);
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  // useCallback so the effect below re-runs (and the socket handlers rebind to
  // a fresh closure) when the selected MT5 account changes — otherwise
  // switching accounts would leave this view showing the old account's trades.
  const reload = useCallback(() => {
    const req = { params: scopeParams };
    Promise.all([
      api.get('/trader/trades/open', req).then(r => setTrades(r.data)),
      api.get('/trader/orders/pending', req).then(r => setPending(r.data)),
    ]).finally(() => setLoading(false));
  }, [scopeParams]);

  useEffect(() => {
    setLoading(true);
    reload();
    const sock = getSocket();
    if (!sock) return undefined;
    const events = [
      'trade:opened', 'trade:modified', 'trade:closed',
      'order:placed', 'order:modified', 'order:cancelled', 'order:triggered',
    ];
    events.forEach(e => sock.on(e, reload));
    return () => events.forEach(e => sock.off(e, reload));
  }, [reload]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Pending Orders ({pending.length})</h5>
              <button className="btn btn-sm btn-info" onClick={reload}>
                <i className="tim-icons icon-refresh-02 mr-1" /> Refresh
              </button>
            </div>
            <div className="card-body">
              {loading ? <p className="text-muted">Loading...</p> : <PendingOrdersTable orders={pending} />}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Open Positions ({trades.length})</h5>
            </div>
            <div className="card-body">
              {loading ? <p className="text-muted">Loading...</p> : <TradeTable trades={trades} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
